import React from 'react'
import { 
  Container,
  Grid,
  Loader  
} from 'semantic-ui-react'

import Users from '../../components/useradmin/users'
import EditUserModal from '../../components/useradmin/editUserModal'
import HeaderForm from '../../components/useradmin/headerForm'
import MessageAlert from '../../components/common/messageAlert'


import { useEffect, useState } from 'react';
import {
  getUser,
  getUsers,
  saveUser,
  deleteUser,
  createUser,
  getFormConfiguration,
  updateUserInExchange
} from '../../utils/useradmin.requestHandler'

import { getUserConfigRequest } from '../../utils/requestHandler';


const Useradmin = () => {

  const [usersLoaded, setUsersLoaded] = useState(false);
  const [configLoaded, setConfigLoaded] = useState(false);
  const [adminWidgetUserConfigLoaded, setAdminWidgetUserConfigLoaded ] = useState(false);


  const [APIData, setAPIData] = useState([]);
  const [configData, setConfigData] = useState([]);
  const [adminWidgetConfigData, setAdminWidgetConfigData] = useState({})


  const [showLoader, toggleLoader] = React.useState(false);
  const [loaderMessage, setLoaderMessage] = React.useState("");
  
  const [searchtext, onChangeSearchText] = React.useState("");
  const [searchMatches, updateSearchMatches] = React.useState(0);
  const [pagesize, updatePageSize] = React.useState(20);

  const [showEditModal, toggleEditModal ]  = React.useState(false);
  
  const [selectedUser, updateSelectedUser ]  = React.useState(null);

  const [filteredUsers, setFilteredUsers] = React.useState([]);

  const [messages, setMessage] = React.useState([])
  const addMessage = (header, msg) => { setMessage( messages => ([...messages, {header:header, content: msg, autoClose: true, autoCloseTime: 5000, type: 'info'}]))}
  const addError = (header, msg) => { setMessage( messages => ([...messages, {header:header, content: msg, autoClose: true, autoCloseTime: 5000, type: 'error'}]))}
  const addWarning = (header, msg) => { setMessage( messages => ([...messages, {header:header, content: msg, autoClose: true, autoCloseTime: 5000, type: 'warning'}]))}


  useEffect(() => {
    if (adminWidgetUserConfigLoaded && configLoaded && !usersLoaded) {

      setLoaderMessage("Laddar användare..")
      toggleLoader(true)

      getUsers(adminWidgetConfigData.db)
        .then(data => {
          setAPIData(data)

          setLoaderMessage("")
          toggleLoader(false)
          setUsersLoaded(true)
        })
        .catch((error) => { 
          setLoaderMessage("")
          toggleLoader(false)
          addWarning("Error loading users", error.message) 
        })
    }
  }, [adminWidgetUserConfigLoaded,configLoaded, usersLoaded])



  useEffect(() => {
    if (adminWidgetUserConfigLoaded && !configLoaded) {
        getFormConfiguration({app: 'adminwidget'})
        .then(data => {
          // console.log(data)
          setConfigData(data)
          setConfigLoaded(true)
        })
        .catch((error) => { addError("error loading form configuration", error.message) })
    }
  }, [adminWidgetUserConfigLoaded, configLoaded])



  useEffect(() => {
    if (!adminWidgetUserConfigLoaded) {
      const puzzeltoken = localStorage.getItem("puzzelToken")
      getUserConfigRequest(puzzeltoken)
        .then(data => {
          //let obj = JSON.parse(data)
          let obj = data
          setAdminWidgetConfigData(obj)
          setAdminWidgetUserConfigLoaded(true)
        })
        .catch((error) => { addError("error loading user configuration", error.message) })
    }
  }, [setAdminWidgetUserConfigLoaded])




  useEffect(() => {

    if (!usersLoaded){
      setFilteredUsers([])
      return
    }

    if ((searchtext === "" && usersLoaded) || (searchtext.length < 3 && usersLoaded ))
    {
      updateSearchMatches(0)
      setFilteredUsers(APIData.slice(0, pagesize))
      return
    }

    let total = []

    // filtering by every property in model works much better with fixes on array filtering.
    let model = APIData.find((element, index) => index === 1)
    for (const property in model) {
      let filtered = APIData.filter((user) => user.hasOwnProperty(property) && user[property] !== null && user[property] !== "" && (user[property].toString()).toLowerCase().match(searchtext.toLowerCase()) !== null)
      total = total.concat(filtered)
    }

    let makeUnique = total.reduce(
      function (unique_arr, obj) {
        if (!unique_arr.some(x => x.key === obj.key)) {
          unique_arr.push(obj)
        }
        return unique_arr;
      }, [])
    
    updateSearchMatches(makeUnique.length)
    setFilteredUsers(makeUnique.slice(0, pagesize))

  }, [searchtext, usersLoaded, APIData, pagesize])


  /* 
    USER CRUD 
  */
  const onEditUser = (key) => {
    toggleEditModal(true)
    let user = APIData.find(user => parseInt(user.key) === parseInt(key))
    updateSelectedUser(user)
  }


  const onSaveUser = (user) => {
    setLoaderMessage("Sparar användaren")
    toggleLoader(true)

    saveUser(user, adminWidgetConfigData.db).then(data => {
      let users = APIData.map( user => parseInt(user.key) === parseInt(data.key) ? {...data} : user );
      setAPIData(users)
      setLoaderMessage("")
      addMessage("", "Sparade användaren");
      toggleLoader(false)


      // SYNC USER IN EXCHANGE
      updateUserInExchange({user: data}).then(data => {
        addMessage("", "Synkade användaren med växeln");
      }).catch((error) => {addError("Error syncing user with exchange", error.message)})

    })
    .catch((error) => { addError("Error saving user", error.message) })
    toggleEditModal(false)
  }


  const onDeleteUser = (key) => {
    setLoaderMessage("Tar bort användaren")
    toggleLoader(true)

    deleteUser(key, adminWidgetConfigData.db).then(data => {
      let users = APIData.filter(user => parseInt(user.key) !== parseInt(key));
      setAPIData(users)

      setLoaderMessage("")
      toggleLoader(false)
      addMessage("", "Tog bort användaren")
    })
    .catch((error) => { addError("Error deleting user", error.message) })
  }

  const onCreateUser = (user) => {
    setLoaderMessage("Skapar användaren")
    toggleLoader(true)
    createUser(user, adminWidgetConfigData.db).then(data => {

      getUser(data.key, adminWidgetConfigData.db).then(data => {
        setAPIData([...APIData, data])
        onChangeSearchText(data.Email)

        setLoaderMessage("")
        toggleLoader(false)
        addMessage("", "Skapade användaren")

      }).catch((error) => { addError("Error fetching new user", error.message) })
    })
    .catch((error) => { addError("Error adding user", error.message) })
  }




  /* SIMPLE */
  const totalcount = () => {return usersLoaded ? APIData.length : 0;}
  const filtered_users_count = () => { return filteredUsers.length; }
  const refresh = ()=>{
    setAPIData([])
    // setAdminWidgetConfigData({})
    setUsersLoaded(false)
    // setAdminWidgetUserConfigLoaded(false)
  }


  return (
    <>
      {
        messages && 
        <div className="puzzel-message-alerts">
          { 
          messages.map((msg, index) =>
            <MessageAlert key={index} msg={msg} />
          )
          }
        </div>
      }

      <Container>
        <Grid>
          <Grid.Column width={16}>

            <HeaderForm 
                usersLoaded={usersLoaded} 
                pagesize={pagesize} 
                updatePageSize={updatePageSize}
                refresh={refresh}
                onChangeSearchText={onChangeSearchText}
                filtered_users_count={filtered_users_count}
                totalcount={totalcount}
                onCreateUser={onCreateUser}
                formConfigData={configData}
                searchMatches={searchMatches}
              />
          </Grid.Column>

          <Grid.Column width={16}>
            <Grid container verticalAlign='middle'>
              <Grid.Column width={1}></Grid.Column>
              <Grid.Column width={16}>
                {
                  usersLoaded &&
                  <Users
                    users={filteredUsers}
                    onEditUser={onEditUser}
                    onDeleteUser={onDeleteUser}
                    formConfigData={configData}
                  />
                }

                {
                showLoader &&
                  <>
                    <div className="puzzel-loader">
                      <div className="puzzel-spinner">
                        <Loader active inverted size='big'>{loaderMessage}</Loader>
                      </div>
                    </div>
                  </>
                }


              </Grid.Column>
              <Grid.Column width={1}></Grid.Column>
            </Grid>
          </Grid.Column>


          {
            showEditModal &&
            selectedUser &&
            <EditUserModal
              user={selectedUser}
              toggleModal={toggleEditModal}
              show={showEditModal}
              saveUser={onSaveUser}
              formConfigData={configData}
            />
          }
        </Grid>
      </Container>
      
    </>
  )
}

export default Useradmin;